import ExceededConversionError from "@/errors/ExceededConversionError";
import ValidationError from "@/errors/ValidationError";
import { hasFreeOperations } from "@/utils/accessControl";
import { getFileExtension } from "@/utils/files";
import { getI18nInstance } from "@/utils/i18n";
import { formatBytes } from "@/utils/miscellaneous";

export const MAX_FILE_SIZE_BYTES = 15728640; // 15MB
export const MAX_FREE_MERGES_PER_DAY = 1;

const ALLOWED_FILE_EXTENSIONS = ["pdf"];

export function validateInputFile(file: File) {
  const i18n = getI18nInstance();

  if (!hasFreeOperations("merge")) {
    throw new ExceededConversionError(
      i18n.translate("pdfextra_merge_tool.errors.max_free_merges", {
        MAX_FREE_MERGES_PER_DAY: MAX_FREE_MERGES_PER_DAY.toString(),
      }),
    );
  }

  if (file.size > MAX_FILE_SIZE_BYTES) {
    throw new ValidationError(
      i18n.translate("pdfextra_merge_tool.errors.file_too_large", {
        MAX_FILE_SIZE: formatBytes(MAX_FILE_SIZE_BYTES),
      }),
    );
  }

  const extension = getFileExtension(file.type);

  if (!ALLOWED_FILE_EXTENSIONS.includes(extension)) {
    throw new ValidationError(
      i18n.translate("pdfextra_merge_tool.errors.not_supported_file_format", {
        allowedExtensions: ALLOWED_FILE_EXTENSIONS.join(", "),
      }),
    );
  }
}
